module.exports = __webpack_public_path__ + "static/ChcsdLogoColor-e521ab4f29d17fb92a5c528ffd48002f.png";